/** Compact population for standings, snapshots, and share copy (e.g. 42.3M). */
export function formatPopulation(value: number): string {
    const n = Math.max(0, Math.round(value));
    if (n >= 1_000_000_000) {
        return `${(n / 1_000_000_000).toFixed(1)}B`;
    }
    if (n >= 1_000_000) {
        return `${(n / 1_000_000).toFixed(1)}M`;
    }
    if (n >= 10_000) {
        return `${Math.round(n / 1_000)}K`;
    }
    return n.toLocaleString();
}
